<script>
import appConfig from '@src/app.config'
export default {
    data() {
        return {
            server: process.env.VUE_APP_SERVER || 'QA',
        }
    },
    page: {
        // All subcomponent titles will be injected into this template.
        titleTemplate(title) {
            title = typeof title === 'function' ? title(this.$store) : title
            return title ? `${title} | ${appConfig.title}` : appConfig.title
        },
    },
    computed: {
        LayoutComponent() {
            return require(`@layouts/${this.$route.meta.layout ||
                'logged-layout'}.vue`).default
        },
    },
    methods: {
        IsProduction() {
            return this.server !== 'PR'
        },
    },
}
</script>

<template>
    <div id="app">
        <div v-if="IsProduction()" class="ribbon ribbon-top-left"
            ><span>{{ $t('Titles.ambientMode') }} [{{ server }}]</span></div
        >

        <transition name="fade" mode="out-in">
            <!-- checa se rota existe para renderizar o layout -->
            <component :is="LayoutComponent" v-if="!!$route.meta.rule">
                <transition name="fade" mode="out-in">
                    <RouterView :key="$route.name" />
                </transition>
            </component>
        </transition>
    </div>
</template>

<style lang="scss">
@import '~normalize.css/normalize.css';
@import '@design';
</style>
